import cx from "classnames";
import dayjs from "dayjs";
import { useContext } from "react";

import { DrawerPageContext } from "../DrawerContainer";
import styles from "./index.module.scss";

type DateIcnProps = {
  isSelected: boolean;
  isDisabled: boolean;
  date: Date;
  onClick: () => void;
};

export const DateIcn = ({
  isSelected = false,
  isDisabled = true,
  date,
  onClick,
}: DateIcnProps) => {
  const { theme } = useContext(DrawerPageContext);

  return (
    <button
      key={dayjs(date).format("YYYYMMDD")}
      className={cx(styles["date__container"])}
      onClick={onClick}
      data-theme={theme}
    >
      <div
        data-theme={theme}
        className={cx({
          [styles["date__inner--default"]]: true,
          [styles["date__inner--selected"]]: isSelected,
          [styles["date__inner--invalid"]]: isDisabled,
        })}
      >
        {dayjs(date).format("DD")}
      </div>
    </button>
  );
};
